export default defineNuxtPlugin(() => {
  const { appName, buildVersion, buildTime } = useRuntimeConfig().public
  console.log(`[${appName ?? 'landing2-ui'}] v${buildVersion} built ${buildTime}`)
})
